import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ApiClientService } from '@tablesready/api-client';

const BASE_URL = '/v.1/reservations';

//TODO: move to shared modules
@Injectable({ providedIn: 'root' })
export class ImportService {
  constructor(
    private readonly http: ApiClientService,
  ) {
  }

  uploadFile (file: File, url: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    if (url) {
      return this.http.post<unknown>(url, formData);
    }

    return this.http.post<unknown>(`${BASE_URL}/fromCSV`, formData);
  }
}
